import { useEffect, useId, useRef } from "react";

export default function ServiceDialog({ title, children, onClose, busy = false }) {
    const titleId = useId();
    const ref = useRef(null);
    const closeRef = useRef(onClose);
    closeRef.current = onClose;
    useEffect(() => {
        const previous = document.activeElement;
        ref.current?.focus();
        return () => previous?.focus();
    }, []);
    const onKeyDown = (event) => {
        if (event.key === "Escape" && !busy) closeRef.current();
        if (event.key !== "Tab") return;
        const controls = [...ref.current.querySelectorAll('button:not(:disabled), input:not(:disabled), a[href], [tabindex="0"]')];
        if (!controls.length) { event.preventDefault(); return; }
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === ref.current)) {
            event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === ref.current)) {
            event.preventDefault(); first.focus();
        }
    };
    return (
        <div className="service-modal-backdrop">
            <section className="service-dialog" ref={ref} tabIndex={-1} role="dialog" aria-modal="true" aria-labelledby={titleId} onKeyDown={onKeyDown}>
                <h2 id={titleId}>{title}</h2>
                {children}
            </section>
        </div>
    );
}

export function serviceError(error, fallback) {
    const detail = error?.response?.data?.detail;
    return typeof detail === "string" ? detail : fallback;
}

export function serviceSessionExpired(error) {
    return error?.response?.status === 401 || (
        error?.response?.status === 403 && error.response.data?.detail === "Сервисные права отозваны"
    );
}
